import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { GetSchoolConfigItemParams, PostSchoolConfigItem, SchoolConfigItemInterface } from "../../interfaces";

export const schoolConfigActions = createActionGroup({
    source: "school-config",
    events: {
        "get config item": props<{
            params: GetSchoolConfigItemParams;
        }>(),
        "set config item data": props<{
            data: {
                params: string;
                data: SchoolConfigItemInterface;
            };
        }>(),
        "save config item": props<{
            data: PostSchoolConfigItem;
            message: string;
        }>(),
        "genrate QR Code": emptyProps(),
        "set QR code": props<{ qrCode: string }>(),
    },
});
